import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { AnalysisResultsTextCommon } from '@sleipai/sleip-models';
import * as AnalysisResultsTextActions from '../actions/analysis-results-text.actions';

export const analysisResultsTextsFeatureKey = 'analysisResultsTexts';

export interface State extends EntityState<AnalysisResultsTextCommon> {
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

export function selectAnalysisResultsTextId(
  analysisResultsText: AnalysisResultsTextCommon
) {
  return analysisResultsText.id ?? '';
}

export function sortByType(
  a: AnalysisResultsTextCommon,
  b: AnalysisResultsTextCommon
) {
  return a.id.localeCompare(b.id);
}

export const adapter: EntityAdapter<AnalysisResultsTextCommon> =
  createEntityAdapter<AnalysisResultsTextCommon>({
    selectId: selectAnalysisResultsTextId,
    sortComparer: sortByType,
  });

export const initialState: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

export const analysisResultsTextReducer = createReducer(
  initialState,

  on(AnalysisResultsTextActions.loadAnalysisResultsTexts, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(
    AnalysisResultsTextActions.loadAnalysisResultsTextsSuccess,
    (state, { data }) =>
      adapter.upsertMany(data, {
        ...state,
        loaded: true,
        loading: false,
      })
  ),
  on(
    AnalysisResultsTextActions.loadAnalysisResultsTextsFailure,
    (state, { error }) => {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: error.message,
      };
    }
  )
);

export const {
  selectIds: selectAnalysisResultsTextIdsAdapter,
  selectEntities: selectAnalysisResultsTextEntitiesAdapter,
  selectAll: selectAllAnalysisResultsAdapter,
  selectTotal: selectAnalysisResultsTextTotalAdapter,
} = adapter.getSelectors();

export function reducer(state: State | undefined, action: Action) {
  return analysisResultsTextReducer(state, action);
}
